import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {DashboardFooter} from '../../footer/FooterComponent';
import {DashboardTopBar} from '../../dashboard-top-bar';
import {InteractionSummaryComponent} from '@techsee/techsee-ui-components/lib/interaction-summary';

export interface IDashboardLayoutStoreProps {
    dashboard?: any;
    children?: React.ReactNode;
}

const mapStoresToProps = (stores: any): IDashboardLayoutStoreProps => ({
    dashboard: stores.dashboardMainStore?.controller ?? stores.dashboardStore?.dashboardMainController
});

@observer
class DashboardLayoutComponent extends TechseeBaseComponent<IDashboardLayoutStoreProps> {
    renderInternal(): JSX.Element {
        const {dashboard} = this.props;

        if (!dashboard) {
            return <React.Fragment />;
        }

        return (
            <div className='dashboard-main-area'>
                {dashboard.topBarController && <DashboardTopBar controller={dashboard.topBarController} />}
                <div className='dashboard-content-area' role='layout' onClick={() => dashboard.toggleTopBar(false)}>
                    {this.props.children}
                </div>

                {!dashboard.libraryTaggingMode && dashboard.footerController && (
                    <DashboardFooter controller={dashboard.footerController} />
                )}

                {dashboard.dashboardState?.isInteractionSummaryReady && (
                    <InteractionSummaryComponent
                        getInteractionSummaryData={dashboard.getInteractionSummaryData}
                        isWidgetOpen={dashboard.openWidgetOnStartUp}
                        getDataOnInitialLoad={dashboard.loadWidgetDataOnStartUp}
                        translated={dashboard.interactionSummaryTranslated}
                        getFormattedDate={dashboard.getDateFormattedByAcc}
                    />
                )}
            </div>
        );
    }
}

export const DashboardLayout = inject(mapStoresToProps)(DashboardLayoutComponent) as IReactComponent;
